// Umrlica.js
import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles
import axios from "axios";

function PreviewMdUmrlica({ multiple }) {
  const modalStyle = {
    border: "7px groove black",
    backgroundColor: "white",
    minHeight: "650px",
    marginTop: "20px",
    width: "100%",
  };
  return (
    <Container style={modalStyle}>
      <Col
        style={{ marginTop: "30px" }}
        className="d-flex justify-content-center"
      >
        <img
          id="umrlica-icon"
          style={{
            height: "50px",
            width: "50px",
            border: "none",
          }}
          src={require("../assets/krst.png")}
          alt="x"
        />
      </Col>
      <Row style={{ paddingTop: "2%" }}>
        <Col className="d-flex justify-content-around"></Col>

        <Col className="d-flex justify-content-around">
          {multiple && (
            <Carousel
              showArrows={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={1000}
            >
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
            </Carousel>
          )}
          {!multiple && (
            <img
              style={{
                width: "150px",
                height: "150px",
                border: "3px solid black",
              }}
              src={require("../assets/user2.png")}
              alt={`Image`}
            />
          )}
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row style={{ paddingTop: "1%" }}>
        <Col
          style={{
            fontWeight: "bold",
            letterSpacing: "1.2px",
            textAlign: "center",
          }}
          className="d-flex justify-content-around"
        >
          Ime Prezime
        </Col>
      </Row>
      <Col className="d-flex justify-content-around">
        <span style={{ fontSize: "small" }}> datum - datum</span>
      </Col>
      <Row>
        <p style={{ padding: "4%" }}>
          Glavni tekst glavni tekst glavni tekst glavni tekst{" "}
        </p>
      </Row>
      <hr></hr>
      <Row>
        <h5 id="sakrij">Ozalošceni:</h5>
        <p id="sakrij">Ozalosceni 1, Ozalosceni 2</p>
      </Row>
    </Container>
  );
}

export default PreviewMdUmrlica;
